import Vue from 'vue'
import Router from 'vue-router'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Index from '@/components/Index'
import index_wx from '@/components/index_wx'
import Contact from '@/components/Contact'
import Award from '@/components/Award'
import Progress from '@/components/Progress'
import Questions from '@/components/Questions'
import News from '@/components/News'
import about_us from '@/components/about-us'
import Customer from '@/components/Customer'
import CustomerDetail from '@/components/CustomerDetail'
import NewsDetail from '@/components/NewsDetail'
import notice from '@/components/notice'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../node_modules/bootstrap/dist/js/bootstrap.min.js'
import '../../node_modules/swiper/dist/js/swiper.min'
import maping from "./meta";

Vue.use(Router);

var route_index = ''
function browserRedirect() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    //移动端
    route_index = index_wx
  } else {
    //pc端
    route_index = Index
  }
}
browserRedirect();

const router = new Router({
  //mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/Header',
      name: 'Header',
      component: Header
    },
    {
      path: '/Footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/',
      name: 'Index',
      component: route_index,  //pc端主页
      meta: maping.index
    },
    {
      path: '/wx',
      name: 'index-wx',
      component: index_wx, //移动端主页
      meta: maping.index
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,  //联系我们(公司介绍)
      meta: maping.contact
    },
    {
      path: '/award',
      name: 'award',
      component: Award,  //荣誉奖项
      meta: maping.award
    },
    {
      path: '/progress',
      name: 'progress',
      component: Progress,  //发展进程
      meta: maping.progress
    },
    {
      path: '/questions',
      name: 'questions',
      component: Questions,  //常见问题
      meta: maping.questions
    },
    {
      path: '/news',
      name: 'news',
      component: News,  //资讯动态
      meta: maping.news
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: NewsDetail,  //客户故事详情
      meta: maping.empty
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: about_us,  //关于我们
      meta: maping.aboutUs
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer,  //客户故事
      meta: maping.customer
    },
    {
      path: '/CustomerDetail',
      name: 'CustomerDetail',
      component: CustomerDetail,  //客户故事详情
      meta: maping.empty
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,  //客户故事详情
      meta: maping.empty
    },
  ]
});
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  console.log(previousNearestWithMeta);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    tag.setAttribute('data-vue-router-controlled', '');
    return tag;
  }).forEach(tag => document.head.appendChild(tag));
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js